import { React } from '../../lib';
import { HelpTooltip } from './help';
const DEFAULT_TRACK_COLOUR = 'oklch(0.82 0 0)';
const FALLBACK_TIER_COLOUR = 'oklch(0.62 0.23 28)';
const DEFAULT_TIERS = [
    { upTo: 20000, colour: 'oklch(0.62 0 0)' },
    { upTo: 60000, colour: 'oklch(0.72 0.16 65)' },
    { upTo: Number.POSITIVE_INFINITY, colour: 'oklch(0.62 0.23 28)' },
];
const DEFAULT_BANNER_COLOURS = [
    'oklch(0.96 0 0)',
    'oklch(0.95 0.045 85)',
    'oklch(0.95 0.05 28)',
];
export const getDefaultUsageLimitBannerColour = (value) => {
    const safeValue = Number.isFinite(value) ? Math.max(0, value) : 0;
    const tierIndex = DEFAULT_TIERS.findIndex(tier => safeValue < tier.upTo);
    return (DEFAULT_BANNER_COLOURS[Math.max(0, tierIndex)] ??
        DEFAULT_BANNER_COLOURS[0] ??
        'transparent');
};
const defaultCurve = (input) => {
    if (input.max <= 0) {
        return 0;
    }
    const normalisedBase = input.max / (input.max + 68000);
    if (normalisedBase <= 0) {
        return 0;
    }
    return input.cappedValue / (input.cappedValue + 68000) / normalisedBase;
};
export const UsageLimitDonut = (props) => {
    const safeValue = Number.isFinite(props.value) ? props.value : 0;
    const safeMax = Number.isFinite(props.max) && props.max > 0 ? props.max : 0;
    const cappedValue = Math.min(Math.max(0, safeValue), safeMax);
    const linearRatio = safeMax > 0 ? cappedValue / safeMax : 0;
    const ratioInput = {
        value: safeValue,
        cappedValue,
        max: safeMax,
        linearRatio,
    };
    const ratio = Math.min(1, Math.max(0, (props.curve ?? defaultCurve)(ratioInput)));
    const tiers = props.tiers ?? DEFAULT_TIERS;
    const colour = typeof tiers === 'function'
        ? tiers(ratioInput)
        : (tiers.find(tier => cappedValue < tier.upTo)?.colour ??
            tiers[tiers.length - 1]?.colour ??
            FALLBACK_TIER_COLOUR);
    const size = props.size ?? 16;
    const thickness = Math.max(1, props.thickness ?? 4);
    const innerSize = Math.max(0, size - thickness * 2);
    const donut = (React.createElement("div", { className: props.className, style: { width: size, height: size, minWidth: size, minHeight: size } },
        React.createElement("div", { className: "rounded-full flex items-center justify-center", style: {
                width: size,
                height: size,
                background: `conic-gradient(${colour} ${(ratio * 100).toFixed(2)}%, ${props.trackColour ?? DEFAULT_TRACK_COLOUR} 0%)`,
            } },
            React.createElement("div", { className: "rounded-full bg-[oklch(var(--chat-l-surface)_0_0)] flex items-center justify-center", style: {
                    width: innerSize,
                    height: innerSize,
                } }, props.children))));
    if (props.tooltipContent == null) {
        return donut;
    }
    const tooltipTitle = typeof props.tooltipContent === 'string' ? (props.tooltipContent) : (React.createElement(React.Fragment, null, props.tooltipContent));
    return React.createElement(HelpTooltip, { title: tooltipTitle }, donut);
};
//# sourceMappingURL=usage-limit-donut.js.map